import { useEffect, useRef } from 'react';
import * as signalR from '@microsoft/signalr';
import { useQueryClient } from 'react-query';
import { API_SERVER } from '../utils/constants';

export const useAlarmDisplaySignalR = () => {
  const queryClient = useQueryClient();
  const connectionRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      console.error('❌ SignalR Token bulunamadı!');
      return;
    }

    if (connectionRef.current) return; // zaten bağlıysa tekrar bağlanma

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_SERVER}/hub?topics=alarms`, {
        accessTokenFactory: () => token,
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
        withCredentials: true,
      })
      .withHubProtocol(new signalR.JsonHubProtocol())
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connectionRef.current = connection;

    connection
      .start()
      .then(() => console.log('✅ SignalR connected: ReceiveAlarmDisplay'))
      .catch(err => {
        console.error('🔌 SignalR bağlantısı başlatılamadı:', err);
      });

    connection.on('ReceiveAlarmDisplay', rawData => {
      try {
        const parsedData =
          typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
        queryClient.setQueryData('alarmsKey', parsedData);
      } catch (err) {
        console.error('❌ ReceiveAlarmDisplay JSON parse hatası:', err);
      }
    });

    return () => {
      connection.off('ReceiveAlarmDisplay');
      connection.stop();
      connectionRef.current = null;
    };
  }, [queryClient]);
};
